import { REDUCER_STATUS } from "helpers/sf_constants"
import {
  EXPORT_ADMIN_BULK_EDIT_JOBS,
  EXPORT_ADMIN_BULK_EDIT_JOBS_ERROR,
  EXPORT_ADMIN_BULK_EDIT_JOBS_SUCCESS,
  GET_ADMIN_BULK_EDIT_JOBS,
  GET_ADMIN_BULK_EDIT_JOBS_ERROR,
  GET_ADMIN_BULK_EDIT_JOBS_SUCCESS,
} from "./actionTypes"

const initialState = {
  error: null,
  bulk_edit_jobs: [],
  loading: false,
  page: 1,
  per_page: 25,
  total_pages: 0,
  total_count: 0,
  status_export: REDUCER_STATUS.UNKNOWN,
  exporting: false,
}

const AdminBulkEditJobs = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_BULK_EDIT_JOBS:
      return {
        ...state,
        loading: true,
      }
    case GET_ADMIN_BULK_EDIT_JOBS_SUCCESS: {
      const pagination = action.payload?.additional_data?.pagination || {}
      return {
        ...state,
        bulk_edit_jobs: Array.isArray(action.payload?.data) ? action.payload.data : [],
        page: pagination.page || 1,
        per_page: pagination.per_page || state.per_page,
        total_pages: pagination.total_pages || 0,
        total_count: pagination.total_count || 0,
        loading: false,
        error: null,
      }
    }
    case GET_ADMIN_BULK_EDIT_JOBS_ERROR:
      return {
        ...state,
        error: action.payload,
        bulk_edit_jobs: [],
        loading: false,
      }
    case EXPORT_ADMIN_BULK_EDIT_JOBS:
      return {
        ...state,
        status_export: REDUCER_STATUS.UNKNOWN,
        exporting: true,
      }
    case EXPORT_ADMIN_BULK_EDIT_JOBS_SUCCESS:
      return {
        ...state,
        status_export: REDUCER_STATUS.OK,
        exporting: false,
      }
    case EXPORT_ADMIN_BULK_EDIT_JOBS_ERROR:
      return {
        ...state,
        status_export: REDUCER_STATUS.ERROR,
        exporting: false,
      }
    default:
      return state
  }
}

export default AdminBulkEditJobs
